import { getScreenData } from "./api-client";

export default {
  data() {
    return {
      showLoader: false,
      LoaderStatus: false,
      screeningCandidates: [],
      goToScreen: null,
      isFilterApplied: false,
      screenPage: 1,
      sortBy: "createdAt",
      sortOrder: -1,
      filterStatus: "",
      storeFilterStatus: "",
      screenFilterCount: 0,
      status: [
        { label: "All", key: "all" },
        { label: "Provided", key: "true" },
        { label: "Not Provided", key: "false" },
      ],
    };
  },
  methods: {
    onScrollScreening(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader
        ) {
          this.showLoader = true;

          this.screenPage++;
          this.fetchScreeningData();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    goBackMobile() {
      this.$router.push({
        name: "PanelLogin",
      });
    },
    clear() {
      if (this.storeFilterStatus !== "") {
        this.showfiltercard = false;
        this.filterStatus = "all";
        this.storeFilterStatus = "all";
        this.screenPage = 1;
        this.screenFilterCount = 0;
        this.LoaderStatus = true;
        this.fetchScreeningData();
      } else {
        this.showfiltercard = false;
        this.filterStatus = "all";
        this.storeFilterStatus = "all";
      }
    },
    openFilter() {
      this.filterStatus = this.storeFilterStatus;
      this.showfiltercard = !this.showfiltercard;
    },
    async applyFilter() {
      this.screenPage = 1;
      this.screenFilterCount++;
      this.storeFilterStatus = this.filterStatus;
      this.LoaderStatus = true;
      await this.fetchScreeningData();
      this.showfiltercard = false;
    },
    updateScreenPage(value) {
      this.pageCount = value;
      this.screenPage = 1;
      this.fetchScreeningData();
    },

    goToScreenPage() {
      this.screenPage = Math.min(Math.max(1, this.goToScreen), this.totalPages);
      this.goToScreen = null;
      this.fetchScreeningData();
    },
    searchPanel() {
      this.screenPage = 1;
      this.LoaderStatus = true;
      this.fetchScreeningData();
    },
    async fetchScreeningData() {
      try {
        if (this.$route.name != "mobresumeScreening") this.LoaderStatus = true;
        const payload = {
          page: this.screenPage - 1,
          count: this.pageCount,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          isSubmitted: this.filterStatus === "all" ? "" : this.filterStatus,
          type: "ASSIGNED",
          searchQuery: this.searchQuery,
        };
        const response = await getScreenData(payload);
        if (response.status === 200) {
          const { pageStart, pageEnd, total, data } = response.data.data;
          if (
            this.screenPage == 1 ||
            this.$route.name != "mobresumeScreening"
          ) {
            this.screeningCandidates = data;
          } else {
            this.screeningCandidates = [...this.screeningCandidates, ...data];
          }
          this.pageStart = pageStart;
          this.pageEnd = pageEnd;
          this.total = total;
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        this.errorModal("Error fetching screening data");
      } finally {
        this.showLoader = false;
        this.LoaderStatus = false;
      }
    },
  },
};
